import type { ExperimentOptionComparisonEvidence } from '@einhaus/project314-types';

const benchmarkStatusText: Record<ExperimentOptionComparisonEvidence['benchmarkStatus'], string> = {
    available_contextual: 'random baseline: contextual coverage',
    available_matched_policy: 'random baseline: contextual coverage (legacy label)',
    partial_coverage: 'random baseline: partial coverage',
    unavailable_incompatible_policy: 'random baseline: incompatible policy',
    unavailable_missing_baseline: 'random baseline: unavailable',
    unavailable_unmatched_execution_window: 'random baseline: unavailable for this historical report'
};

/** The denominator is recorded entry/horizon attempts, never raw stock labels. */
export function formatOptionOutcomeCompletion(evidence: ExperimentOptionComparisonEvidence | undefined): string {
    if (!evidence || evidence.evidenceCutoffTimestamp === null) return 'Unavailable';
    return `${evidence.completedCount}/${evidence.recordedAttemptCount}`;
}

export function OptionOutcomeCompletion({ evidence }: { evidence: ExperimentOptionComparisonEvidence | undefined }) {
    const available = evidence !== undefined && evidence.evidenceCutoffTimestamp !== null;
    const detail = available
        ? `Policy ${evidence.policyRevision}: completed / recorded entry-horizon attempts. ` +
          `Not entered: ${evidence.notEnteredCount}; pending settlement: ${evidence.pendingSettlementCount}; ` +
          `censored: ${evidence.openCensoredCount}; missing data: ${evidence.missingDataCount}; ` +
          `unsupported: ${evidence.unsupportedCapabilityCount}; failed: ${evidence.evaluationFailureCount}; ` +
          `completed outside eligibility or without profit: ${evidence.ineligibleCompletedCount}; ` +
          `${benchmarkStatusText[evidence.benchmarkStatus]}.` +
          (evidence.rejectionReasons?.length
              ? ` Most frequent reasons: ${evidence.rejectionReasons.map((reason) => `${reason.count} × ${reason.detail ?? reason.code}`).join('; ')}.`
              : '')
        : 'No current-policy option evidence is available.';
    return (
        <span className={available ? 'text-white' : 'text-zinc-500'} title={detail}>
            {formatOptionOutcomeCompletion(evidence)}
        </span>
    );
}
